export default {
  toggleLockEdit(state, { val }) {
    state.lockEditAll = val
  },
  updateAvailableNodeWhenLockEdit(state, { nodes }) {
    state.availableNodeWhenLockEdit = nodes
  }
}
